module.exports = __webpack_public_path__ + "img/ic_market_line.e2fce0b1.svg";